<app-header isMinimized="true"></app-header>

<section class="products">
  <app-filter class="products__filter" isFixed="true"></app-filter>
  <app-products class="products__products"></app-products>
</section>

<app-footer></app-footer>
